<div class="risk-severity {{riskNormalized}}">
  <ng-container *ngIf="riskNormalized !== 'unknown'">
    <img src="/assets/icons/icon-risk-{{riskNormalized}}.svg" alt="Risk Icon" />
    {{riskLabel}}
  </ng-container>
  <ng-container *ngIf="riskNormalized === 'unknown'">
    N/A
  </ng-container>
</div>